module.exports = __webpack_public_path__ + "static/media/112-1.bc55d148.jpg";